import styledComponents from 'styled-components';

export const ErrorMessage = styledComponents.p`
    color: red;
`;
